<div class="basic-components">
    <h2>{{ title }}</h2>
    <h6>
        {{ errorDescription }}
    </h6>
    <div class="ml-10">
        <img class="image-clave" src="assets/images/Clave.png" title="Identificación con Cl@ve - Sistema de Identificación para las Administraciones Públicas" />
    </div>
</div>
